module.exports = __webpack_public_path__ + "static/media/B6_banner.0642ce88.svg";